// GENERATED FILE -- do not edit by hand.
// Regenerate with `npm run codegen:stores` (see frontend/package.json).
// Source: agent.app.deployment.deployment_service.DeploymentService

import { makeObservable, observable } from "mobx";
import { applyJsonPatch, JsonPatchOp } from "@/app_store/rpc/json_patch";
import { AgentTransport, callRpc } from "@/app_store/rpc/rpc";
import { registerEntity, wrapEntity } from "@/app_store/rpc/entity";

export interface DeploymentServiceData {
    // Stamped onto every @observable model's dump at runtime (see
    // common._ObservableMixin._serialize_with_tag) -- tells wrapEntity which
    // generated Store class this value belongs to. Never sent by a client.
    _entity_class_name: "DeploymentService";
    name: string;
    status: string;
}

export class DeploymentServiceStore {
    readonly _entity_class_name = "DeploymentService" as const;
    name: string;
    status: string;
    private _transport: AgentTransport;
    private _chainPath: string[];

    constructor(data: DeploymentServiceData, transport: AgentTransport, chainPath: string[] = []) {
        this._transport = transport;
        this._chainPath = chainPath;
        this.name = wrapEntity(data.name, transport, [...chainPath, "name"]);
        this.status = wrapEntity(data.status, transport, [...chainPath, "status"]);
        makeObservable(this, {
            name: observable,
            status: observable,
        });
    }

    applyPatch(op: JsonPatchOp): void {
        applyJsonPatch(this, op);
    }

    async deploy(): Promise<any> {
        return callRpc(this._transport, this._chainPath, "deploy", [], {});
    }

    async stop(): Promise<any> {
        return callRpc(this._transport, this._chainPath, "stop", [], {});
    }

    async restart(): Promise<any> {
        return callRpc(this._transport, this._chainPath, "restart", [], {});
    }

    async logs(lines?: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "logs", [lines], {});
    }
}

registerEntity("DeploymentService", DeploymentServiceStore);
